
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import styles from './helpAndSupport.module.css';
import global from '../bid.module.css';

type Props = {
    title: string,
    text: string,
    posts: [
        {
            _source: {
                post_id: string,
                permalink: string,
                post_title: string,
                meta: {
                    insight_category: [
                        {
                            value: string
                        }
                    ]
                }
                featured_image: {
                    value: {
                        alt: string
                        sizes: {
                            large: string
                        }
                    }
                }
            }
        }
    ]
}

const HelpAndSupport = ({ title, text, posts }: Props) => {
    return (
        <div className={`${styles.Container} ${global.Container}`} id="insights">
            <h3 className={styles.Heading}>{title}</h3>
            <p className={styles.SubHeading}>{text}</p>
            <Grid container alignItems="center" justifyContent="center" spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
                {posts && posts.map((post) => {
                    const postSource = post._source;
                    return (
                        <Grid item xs={12} sm={6} md={4} key={`help-${postSource.post_id}`}>
                            <a href={postSource.permalink} target="_blank">
                                <Card sx={{ boxShadow: 'none' }}>
                                    <CardMedia
                                        sx={{ height: 200 }}
                                        image={postSource.featured_image ? postSource.featured_image.value.sizes.large : "images/news_1.jpg"}
                                        title={postSource.featured_image ? postSource.featured_image.value.alt : "news"}
                                        component="img"
                                        loading="lazy"
                                    />
                                    <CardContent sx={{ backgroundColor: '#EFEFEF', minHeight: '120px' }}>
                                        {postSource?.meta?.insight_category && (
                                            <Typography variant="subtitle1" component="p" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }} gutterBottom>{postSource.meta.insight_category[0].value}</Typography>
                                        )}
                                        <Typography sx={{ fontSize: '14.4px' }} dangerouslySetInnerHTML={{ __html: postSource.post_title }} variant="body2" gutterBottom />
                                    </CardContent>
                                </Card>
                            </a>
                        </Grid>
                    )
                })}

            </Grid>

        </div>
    )
}

export default HelpAndSupport;